<template>
  <div class="login-as-new">
    <el-tooltip class="item" effect="dark" :content="`Login as ${user.first_name} on app.syncvault.com`" placement="top">
      <i class="el-icon-s-promotion" @click="loginAsUserNew"></i>
    </el-tooltip>
  </div>
</template>

<script>
import axios from '@/plugins/axios'

export default {
  props: {
    user: { type: Object, default: () => ({}) }
  },

  methods: {
    async loginAsUserNew() {
      try {
        const response = await axios.admin.post(`user/login-as/${this.user.id}`);

        if (response.data.access_token) {
          const token = encodeURIComponent(response.data.access_token);
          const secret = encodeURIComponent(response.data.admin_secret_key);

          const targetUrl = `${process.env.VUE_APP_NEW_FRONT_URL}admin-login?token=${token}&secret=${secret}`;

          window.open(targetUrl, '_blank', 'noopener');
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.login-as-new {
  display: inline-block;
  cursor: pointer;
}
</style>